import store from "../../store";
import api from "../request";
import qs from "qs";
import { Promise } from "q";


  function getMyHealthData(reqData) {
    return api
      .post("health/get", { reqData })
      .then(({ data }) => {
        return data;
      })
  }

  function getLeaderBoardData(reqData) {
    return api
      .post("health/leaderboard", { reqData })
      .then(({ data }) => {
        return data;
      })
  }
  function getHealthData(reqData) {
    return api
      .post("health/get-data", { reqData })
      .then(({ data }) => {
        return data;
      })
  }
  export default {
    getMyHealthData,
    getLeaderBoardData,
    getHealthData
};